export enum ReviewContentStatus {
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
    COMPLAINT = 'COMPLAINT',
    REJECTED = 'REJECTED',
}

export interface ReviewContentPhoto {
    s3_key: string;
}

export interface ReviewContentItem {
    review_content_id: number;
    survey_response_id: number;
    review_id?: number | null;
    s3_key: string;
    description?: string | null;
    rejection_reason?: string | null;
    complaint_reason?: string | null;
    sort_order: number;
    ai_validation_status: ReviewContentStatus;
    read_url?: string | null;
}

/** Allowed rejectionReason values from the guest content photo validation prompt. */
export const GUEST_CONTENT_PHOTO_REJECTION_REASONS = [
    'A child or minor is visible.',
    'An identifiable face is visible.',
    'A vehicle license plate is visible.',
    'Personal information or a personal document is visible.',
    'A readable access code or private access instruction is visible.',
    'An exterior security camera location is visible.',
    'A visible secret or access code is present.',
    'Sexual, nude, or suggestive content is visible.',
    'A firearm or weapon is visible.',
    'Drugs or drug paraphernalia are visible.',
    'Gore, blood, or graphic violence is visible.',
    'Hate symbols or extremist group imagery is visible.',
    'Prohibited text or content is visible.',
    'External promotion or a third-party website is visible.',
] as const;

export type GuestContentPhotoRejectionReason = typeof GUEST_CONTENT_PHOTO_REJECTION_REASONS[number];

/** Allowed complaintReason values from the guest content photo validation prompt. */
export const GUEST_CONTENT_PHOTO_COMPLAINT_REASONS = [
    'Damage or broken property is visible.',
    'Severe dirt, mess, or unclean conditions are visible.',
    'A maintenance or repair issue is visible.',
    'Missing, broken, or non-working amenities are visible.',
    'Pest or infestation evidence is visible.',
    'A safety or habitability concern is visible.',
    'Other stay problem evidence is visible.',
] as const;

export type GuestContentPhotoComplaintReason = typeof GUEST_CONTENT_PHOTO_COMPLAINT_REASONS[number];

export type GuestContentPhotoClassification = 'APPROVED' | 'COMPLAINT' | 'REJECTED';

export interface GuestContentPhotoAiReview {
    description: string;
    classification: GuestContentPhotoClassification;
    rejectionReason: GuestContentPhotoRejectionReason | null;
    complaintReason: GuestContentPhotoComplaintReason | null;
}
